<script setup>
import { ref } from 'vue';

defineProps({
	loading: { type: Boolean, default: false }
});

const emit = defineEmits(['submit-file', 'load-example']);

const fileInput = ref(null);

function onSubmit() {
	const file = fileInput.value && fileInput.value.files[0];
	if (!file) {
		alert('Please select a CSV file to upload.');
		return;
	}
	emit('submit-file', file);
}

function onLoadExample() {
	if (fileInput.value) fileInput.value.value = '';
	emit('load-example');
}
</script>

<template>
	<form class="tnt-upload-form" @submit.prevent="onSubmit">
		<input ref="fileInput" type="file" />
		<button type="submit" class="btn btn-primary" :disabled="loading">Submit</button>
		<button type="button" class="btn btn-secondary" :disabled="loading" @click="onLoadExample">Load Example Results</button>
	</form>

	<div v-if="loading" class="tnt-ingest-status" style="display: block">Ingesting your file. Might take a minute or two. Will timeout after 5 minutes.</div>
</template>
